import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, Search, ShoppingBag, X } from "lucide-react";
import { useStore } from "../../context/StoreContext";
import { waLink } from "../../lib/whatsapp";
import { Logo } from "./Logo";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { Sheet, SheetContent, SheetTitle } from "../ui/sheet";

export const NAV = [
  { to: "/", label: "Início" },
  { to: "/catalogo", label: "Catálogo" },
  { to: "/catalogo?tag=launch", label: "Lançamentos" },
  { to: "/catalogo?tag=promo", label: "Promoções" },
  { to: "/sobre", label: "Sobre" },
];

function SearchBox({ onDone, testid }) {
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    navigate(`/catalogo${q.trim() ? `?q=${encodeURIComponent(q.trim())}` : ""}`);
    onDone?.();
  };
  return (
    <form onSubmit={submit} className="relative w-full" role="search">
      <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-[#D4AF37]/70" />
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Buscar perfume ou marca"
        className="w-full rounded-full border border-[#D4AF37]/20 bg-white/[0.03] py-2.5 pl-11 pr-4 text-sm text-[#FAF6F0] outline-none transition-[border-color] placeholder:text-[#A1A1AA]/60 focus:border-[#D4AF37]/60"
        data-testid={testid}
      />
    </form>
  );
}

export default function Header() {
  const { settings, selection, setDrawerOpen } = useStore();
  const [open, setOpen] = useState(false);
  const count = selection.length;

  return (
    <header className="sticky top-0 z-40 border-b border-[#D4AF37]/15 bg-[#0B0B0C]/85 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-20 max-w-7xl items-center gap-4 px-5 lg:px-8">
        <button className="text-[#F3E5AB] lg:hidden" onClick={() => setOpen(true)} aria-label="Abrir menu" data-testid="header-mobile-menu-button">
          <Menu className="h-6 w-6" />
        </button>
        <Link to="/" className="shrink-0" data-testid="header-logo"><Logo settings={settings} /></Link>
        <nav className="ml-8 hidden items-center gap-7 lg:flex">
          {NAV.map((n) => (
            <NavLink key={n.label} to={n.to} end className="text-[13px] uppercase tracking-[0.18em] text-[#A1A1AA] transition-colors hover:text-[#F3E5AB]" data-testid={`nav-link-${n.label.toLowerCase()}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="ml-auto hidden w-64 md:block xl:w-72"><SearchBox testid="header-search-input" /></div>
        <div className="ml-auto flex items-center gap-2 md:ml-2">
          {settings?.whatsapp && (
            <a href={waLink(settings.whatsapp, "Olá! Gostaria de mais informações sobre os perfumes da EMAIA PERFUMES.")} target="_blank" rel="noopener noreferrer"
              className="flex h-10 w-10 items-center justify-center rounded-full text-[#25D366] transition-colors hover:bg-[#25D366]/10" aria-label="WhatsApp" data-testid="header-whatsapp-link">
              <WhatsAppIcon className="h-5 w-5" />
            </a>
          )}
          <button onClick={() => setDrawerOpen(true)} className="relative flex h-10 w-10 items-center justify-center rounded-full text-[#F3E5AB] transition-colors hover:bg-[#D4AF37]/10" aria-label="Minha seleção" data-testid="header-selection-button">
            <ShoppingBag className="h-5 w-5" />
            {count > 0 && (
              <span className="absolute -right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-[#D4AF37] px-1 text-[10px] font-bold text-[#0B0B0C]" data-testid="header-selection-count">{count}</span>
            )}
          </button>
        </div>
      </div>
      <div className="px-5 pb-3 md:hidden"><SearchBox testid="header-search-input-mobile" /></div>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-[85%] max-w-sm border-r border-[#D4AF37]/20 bg-[#0B0B0C] p-0 [&>button]:hidden" data-testid="mobile-menu">
          <SheetTitle className="sr-only">Menu</SheetTitle>
          <div className="flex items-center justify-between border-b border-[#D4AF37]/15 p-6">
            <Logo settings={settings} />
            <button onClick={() => setOpen(false)} className="text-[#A1A1AA]" aria-label="Fechar menu" data-testid="mobile-menu-close"><X className="h-5 w-5" /></button>
          </div>
          <nav className="flex flex-col p-6">
            {NAV.map((n) => (
              <Link key={n.label} to={n.to} onClick={() => setOpen(false)} className="border-b border-white/5 py-4 font-serif text-2xl text-[#FAF6F0] transition-colors hover:text-[#D4AF37]" data-testid={`mobile-nav-${n.label.toLowerCase()}`}>
                {n.label}
              </Link>
            ))}
          </nav>
        </SheetContent>
      </Sheet>
    </header>
  );
}
